import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useGetQuoteTrackingAnalyticsQuery } from '../../app/userApi/userApi';
import './UserTracking.css';
import Button from '../../components/shared/buttons/button';
import { Tabs, Tab } from 'react-bootstrap';
import TrackingUsers from './TrackingUsers';
const UserTracking = () => {
  const location = useLocation();
  const activeTabFromState = location.state?.activeTab || 'users';
  const today = new Date().toISOString().split('T')[0];
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [appliedFilters, setAppliedFilters] = useState({ from: today, to: today });

  const { data: trackingData, isLoading, isFetching } = useGetQuoteTrackingAnalyticsQuery(
    { from: appliedFilters.from, to: appliedFilters.to },
    // { skip: !appliedFilters.from || !appliedFilters.to }
  );

  const analyticsData = trackingData?.data;
  const hasData = analyticsData && analyticsData.steps && analyticsData.steps.length > 0;

  const handleApplyFilter = () => {
    if (fromDate && toDate) {
      setAppliedFilters({ from: fromDate, to: toDate });
    }
  };

  // Color gradient for progress bars
  const getBarColor = (index) => {
    const colors = [
      '#2196F3', // Blue
      '#4CAF50', // Green
      '#8BC34A', // Light Green
      '#CDDC39', // Lime
      '#FFC107', // Amber
      '#FF9800', // Orange
      '#F44336', // Red
    ];
    return colors[index % colors.length];
  };

  return (
      <div className="user-tracking-container p-0 ">
         <Tabs defaultActiveKey={activeTabFromState} id="user-tabs" className="mb-3">
        <Tab eventKey="users" title="Tracking info">
      <div className="analytics-card mt-4">
        <div className="card-header">
        </div>

        <div className="filter-section">
          <div className="filter-group">
            <label>From:</label>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => {
                setFromDate(e.target.value);
                if (toDate && e.target.value > toDate) {
                  setToDate(e.target.value);
                }
              }}
              className="date-input"
            />
          </div>
          <div className="filter-group">
            <label>To:</label>
            <input
              type="date"
              value={toDate}
              min={fromDate}
              onChange={(e) => setToDate(e.target.value)}
              className="date-input"
            />
          </div>
          
           <Button
                              label={'  Apply Filter'}
                              onClick={handleApplyFilter}
            disabled={!fromDate || !toDate}
                          />
        </div>

        {(isLoading || isFetching) && (
          <div className="loading-indicator">Loading analytics...</div>
        )}

        {!isLoading && !isFetching && !hasData && (
          <div className="no-records">
            <span className="no-records-icon">📊</span>
            <p>No records found</p>
            <span className="no-records-hint">Please select a date range and apply filter</span>
          </div>
        )}

        {hasData && (
          <>
            <div className="funnel-steps">
              {analyticsData.steps.map((step, index) => (
                <div key={index} className="step-row">
                  <div className="step-info">
                    <span className="step-name">{step.step}</span>
                    <span className="step-users">{step.users.toLocaleString()} users</span>
                  </div>
                  <div className="progress-container">
                    <div 
                      className="progress-bar"
                      style={{ 
                        width: `${step.percentage}%`,
                        backgroundColor: getBarColor(index, analyticsData.steps.length)
                      }}
                    >
                      <span className="percentage-label">{step.percentage}%</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="summary-section">
              <div className="summary-left">
                <span className="summary-label">Total Sessions:</span>
                <span className="summary-value">{analyticsData.totalSessions.toLocaleString()}</span>
              </div>
              <div className="summary-right">
                <span className="summary-label">Conversion Rate:</span>
                <span className="summary-value">{analyticsData.conversionRate}%</span>
              </div>
            </div>

            <div className="dropoff-alert">
              <span className="alert-icon">⚠</span>
              <span className="alert-text">
                Highest drop-off observed between{' '}
                <strong>{analyticsData.highestDropOff.split('→')[0].trim()}</strong>
                {' → '}
                <strong>{analyticsData.highestDropOff.split('→')[1]?.trim()}</strong>
              </span>
            </div>
          </>
        )}
      </div>
        </Tab>
        <Tab eventKey="odoUsers" title="Tracking Users">
          <TrackingUsers />
        </Tab>
      </Tabs>
    
    </div>
  );
};

export default UserTracking;
